import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import BlockHeroOrganism from '~/components/_next/organisms/BlockHeroOrganism.vue';
import BlockImagesTextGraphql from '~/components/Organisms/BlockImagesTextGraphql.vue';
import BlockCardListGraphql from '~/components/Organisms/BlockCardListGraphql.vue';
import BlockProductsRecommendationGraphql from '~/components/Organisms/BlockProductsRecommendationGraphql.vue';
import BlockTabsWithBannerGraphql from '~/components/Organisms/BlockTabsWithBannerGraphql.vue';
import BlockAdviceTabsWithBannerGraphql from '~/components/Organisms/BlockAdviceTabsWithBannerGraphql.vue';
import BlockOurEngagementsGraphql from '~/components/Organisms/BlockOurEngagementsGraphql.vue';
import BlockSeoMainTitleGraphql from '~/components/Organisms/BlockSeoMainTitleGraphql.vue';
import BlockRatingsAndReviewsGraphql from '~/components/Organisms/BlockRatingsAndReviewsGraphql.vue';
import BlockSocialPostsGraphql from '~/components/Organisms/BlockSocialPostsGraphql.vue';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
import { useSegment } from '~/composables/_next/useSegment';
import { useTrpc } from '~/composables/_next/useTrpc';
import { acceptLanguage } from '~/i18n.config';
import { cacheControl } from '~/helpers/cacheControl';
import { useLocalization } from '~/composables/_next/useLocalization';
const __nuxt_page_meta = {
  middleware: [cacheControl('public, s-maxage=1800, stale-while-revalidate=300, stale-if-error=300') // 30 minutes cache and 5 minutes stale
      ],tracking: {
        category: TrackingPageCategory.HOME
      }
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: 'index',
  setup: function setup(__props) {
    ;
    onMounted(function () {
      // TODO: Remove after Nuxt 3 migration
      var _useSegment = useSegment(),
        trackPage = _useSegment.trackPage;
      trackPage(TrackingPageCategory.ALP, PageTypes.ALP);
    });
    var _useNuxt2App = useNuxt2App(),
      $flag = _useNuxt2App.$flag;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR,
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta;
    var homeContent = useState('home-content', function () {
      return null;
    });
    var seoMeta = useState('home-seo', function () {
      return null;
    });
    var customHomepage = $flag.get('enableCustomHomepage');
    useLazyAsyncData('home-fetch-content', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _homeContent$value$da, _homeContent$value$da2, _homeContent$value$da3, _homeContent$value$da4, _homeContent$value$da5, _homeContent$value$da6;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!customHomepage) {
              _context.next = 8;
              break;
            }
            if (homeContent.value) {
              _context.next = 5;
              break;
            }
            _context.next = 4;
            return client.contentful.getCustomHomepage.query({
              locale: locale
            });
          case 4:
            homeContent.value = _context.sent;
          case 5:
            seoMeta.value = Object.assign({}, (_homeContent$value$da = homeContent.value.data) === null || _homeContent$value$da === void 0 ? void 0 : (_homeContent$value$da2 = _homeContent$value$da.pageHomepageCollection) === null || _homeContent$value$da2 === void 0 ? void 0 : (_homeContent$value$da3 = _homeContent$value$da2.items[0]) === null || _homeContent$value$da3 === void 0 ? void 0 : _homeContent$value$da3.seo, {
              slug: Object.fromEntries(acceptLanguage.map(function (lang) {
                return [lang, '/'];
              }))
            });
            _context.next = 13;
            break;
          case 8:
            if (homeContent.value) {
              _context.next = 12;
              break;
            }
            _context.next = 11;
            return client.contentful.getHomepage.query({
              locale: locale
            });
          case 11:
            homeContent.value = _context.sent;
          case 12:
            seoMeta.value = Object.assign({}, (_homeContent$value$da4 = homeContent.value.data) === null || _homeContent$value$da4 === void 0 ? void 0 : (_homeContent$value$da5 = _homeContent$value$da4.pageBasicCollection) === null || _homeContent$value$da5 === void 0 ? void 0 : (_homeContent$value$da6 = _homeContent$value$da5.items[0]) === null || _homeContent$value$da6 === void 0 ? void 0 : _homeContent$value$da6.seo, {
              slug: Object.fromEntries(acceptLanguage.map(function (lang) {
                return [lang, '/'];
              }))
            });
          case 13:
            setMeta(seoMeta.value);
            return _context.abrupt("return", true);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var componentMap = {
      BlockProductsRecommendation: BlockProductsRecommendationGraphql,
      BlockImagesText: BlockImagesTextGraphql,
      BlockCardList: BlockCardListGraphql,
      BlockTabsWithBanner: BlockTabsWithBannerGraphql,
      BlockAdviceTabsWithBanner: BlockAdviceTabsWithBannerGraphql,
      BlockOurEngagements: BlockOurEngagementsGraphql,
      BlockSeoMainTitle: BlockSeoMainTitleGraphql,
      BlockRatingsAndReviews: BlockRatingsAndReviewsGraphql,
      BlockSocialPosts: BlockSocialPostsGraphql
    };
    var orderedComponents = computed(function () {
      var _homeContent$value, _homeContent$value$da7, _homeContent$value$da8, _homeContent$value$da9, _homeContent$value$da0;
      return ((_homeContent$value = homeContent.value) === null || _homeContent$value === void 0 ? void 0 : (_homeContent$value$da7 = _homeContent$value.data) === null || _homeContent$value$da7 === void 0 ? void 0 : (_homeContent$value$da8 = _homeContent$value$da7.pageHomepageCollection) === null || _homeContent$value$da8 === void 0 ? void 0 : (_homeContent$value$da9 = _homeContent$value$da8.items[0]) === null || _homeContent$value$da9 === void 0 ? void 0 : (_homeContent$value$da0 = _homeContent$value$da9.contentCollection) === null || _homeContent$value$da0 === void 0 ? void 0 : _homeContent$value$da0.items.map(function (block) {
        return {
          component: componentMap[block.__typename],
          props: _objectSpread({}, block)
        };
      })) || [];
    });
    function getComponent(componentName) {
      var _homeContent$value2, _homeContent$value2$d, _homeContent$value2$d2, _homeContent$value2$d3, _homeContent$value2$d4, _homeContent$value3, _homeContent$value3$d, _homeContent$value3$d2, _homeContent$value3$d3, _homeContent$value3$d4;
      var sourceCollection = customHomepage ? ((_homeContent$value2 = homeContent.value) === null || _homeContent$value2 === void 0 ? void 0 : (_homeContent$value2$d = _homeContent$value2.data) === null || _homeContent$value2$d === void 0 ? void 0 : (_homeContent$value2$d2 = _homeContent$value2$d.pageHomepageCollection) === null || _homeContent$value2$d2 === void 0 ? void 0 : (_homeContent$value2$d3 = _homeContent$value2$d2.items[0]) === null || _homeContent$value2$d3 === void 0 ? void 0 : (_homeContent$value2$d4 = _homeContent$value2$d3.contentCollection) === null || _homeContent$value2$d4 === void 0 ? void 0 : _homeContent$value2$d4.items) || [] : ((_homeContent$value3 = homeContent.value) === null || _homeContent$value3 === void 0 ? void 0 : (_homeContent$value3$d = _homeContent$value3.data) === null || _homeContent$value3$d === void 0 ? void 0 : (_homeContent$value3$d2 = _homeContent$value3$d.pageBasicCollection) === null || _homeContent$value3$d2 === void 0 ? void 0 : (_homeContent$value3$d3 = _homeContent$value3$d2.items[0]) === null || _homeContent$value3$d3 === void 0 ? void 0 : (_homeContent$value3$d4 = _homeContent$value3$d3.blocsCollection) === null || _homeContent$value3$d4 === void 0 ? void 0 : _homeContent$value3$d4.items) || [];
      return sourceCollection.filter(function (block) {
        var _block$__typename;
        return ((_block$__typename = block.__typename) === null || _block$__typename === void 0 ? void 0 : _block$__typename.toLowerCase()) === (componentName === null || componentName === void 0 ? void 0 : componentName.toLowerCase());
      });
    }
    var hero = computed(function () {
      return getComponent('BlockHero')[0];
    });
    onMounted(function () {
      setDynamicYieldContext('HOMEPAGE');
    });
    setDynamicYieldContextSSR('HOMEPAGE');
    return {
      __sfc: true,
      $flag: $flag,
      locale: locale,
      client: client,
      setDynamicYieldContextSSR: setDynamicYieldContextSSR,
      setDynamicYieldContext: setDynamicYieldContext,
      setMeta: setMeta,
      homeContent: homeContent,
      seoMeta: seoMeta,
      customHomepage: customHomepage,
      componentMap: componentMap,
      orderedComponents: orderedComponents,
      getComponent: getComponent,
      hero: hero,
      AzBackToTopButton: AzBackToTopButton,
      BlockHeroOrganism: BlockHeroOrganism,
      BlockImagesTextGraphql: BlockImagesTextGraphql,
      BlockCardListGraphql: BlockCardListGraphql,
      BlockProductsRecommendationGraphql: BlockProductsRecommendationGraphql,
      BlockTabsWithBannerGraphql: BlockTabsWithBannerGraphql,
      BlockAdviceTabsWithBannerGraphql: BlockAdviceTabsWithBannerGraphql,
      BlockOurEngagementsGraphql: BlockOurEngagementsGraphql,
      BlockSeoMainTitleGraphql: BlockSeoMainTitleGraphql,
      BlockRatingsAndReviewsGraphql: BlockRatingsAndReviewsGraphql,
      BlockSocialPostsGraphql: BlockSocialPostsGraphql
    };
  }
});